import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import car from './modules/car'
import submission from './modules/submission'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    car,
    submission
  },
  strict: process.env.NODE_ENV !== 'production'
})
